module.exports = __webpack_public_path__ + "img/COOPERATIVE.94af97a2.png";